import React from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label, { useLabels } from "components/general/Label";
import { getMedallists } from "data/Querys";
import NotAvailable from "components/common/NotAvailable";
import Loader from "components/general/Loader";
import { useQuery } from "@tanstack/react-query";
import NocMedallistsTable from "components/common/medals/NocMedallistsTable";
import Medal from "components/presentation/Medal";
import TextLegen from "components/common/TextLegen";
import { LegendProvider } from "components/common/legendContext";
import { CleanLegends } from "components/common/CleanLegends";
import { LegendsBox } from "components/common/LegendsBox";

export default function MedallistsByNoc() {
  const { mirs_competition, mirs_language, mirs_noc } = useUrlFriendlyToParameters();
  const [dataState, setDataState] = React.useState([]);
  const fLabel = useLabels();
  const { data, isError, isLoading } = useQuery({
    queryKey: ["medalTable", mirs_competition, mirs_language],
    queryFn: getMedallists,
    refetchInterval: 60000,
  });


  React.useEffect(() => {
    let filterData = data?.medallist?.filter((item) => item?.participant?.organisation?.code === mirs_noc);
    setDataState(filterData || []);
  }, [data, mirs_noc, isError, isLoading]);

  if (isError) { return <NotAvailable label="LabelNoDataAvailable" />; }
  if (isLoading) { return <Loader />; }




  return (
    <>

      <LegendProvider>
        <CleanLegends />
        <div className='mirs-page-container'>
          <TextLegen code='1Medal' icon={<Medal code={"1"} />} description={fLabel({ data: 'HeaderGold' })} onlyLegend={true} />
          <TextLegen code='2Medal' icon={<Medal code={"2"} />} description={fLabel({ data: 'HeaderSilver' })} onlyLegend={true} />
          <TextLegen code='3Medal' icon={<Medal code={"3"} />} description={fLabel({ data: 'HeaderBronze' })} onlyLegend={true} />

          <NocMedallistsTable
            data={dataState}
            eventorder={"NOC"}
            key={`medallists`}
          />
          {(!dataState || dataState.length === 0) && <NotAvailable label="LabelNoDataAvailable" />}
        </div>
        <LegendsBox />
      </LegendProvider>

    </>
  );
}
